export const PROJECT_INVALIDATE_GET_PROJECTS_CACHE =
	'REALTIME.COMMON.PROJECT_INVALIDATE_GET_PROJECTS_CACHE';
export const REVOKE_USER_TOKEN_MESSAGE = 'REALTIME.COMMON.REVOKE_USER_TOKEN_MESSAGE';
